import checkTemplateHeader from "./checkTemplateHeader.rtf";
import checkTemplatePagePrototype from "./checkTemplatePagePrototype.rtf";

export const CHECK_TEMPLATE_HEADER = checkTemplateHeader;

export const CHECK_TEMPLATE_PAGE_PROTOTYPE = checkTemplatePagePrototype;

import checkTemplateVendorPrototype from "./checkTemplateVendorPrototype.rtf";
export const CHECK_TEMPLATE_VENDOR_PROTOTYPE = checkTemplateVendorPrototype;

export const CHECK_TEMPLATE_PAGE_SEPARATOR = "\\page\n";

export const CHECK_TEMPLATE_FOOTER = "}";
